import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { ILayoutStore } from '../../store/LayoutStore'
import { IUserStore } from '../../store/UserStore'
import { IWeekConsumptionStore } from '../../store/WeekConsumptionStore'
import DayConsumption from '../DayConsumption/DayConsumption'

interface IStepDayConsumptionProps {
  LayoutStore?: ILayoutStore
  UserStore?: IUserStore
  WeekConsumptionStore?: IWeekConsumptionStore
}

@inject('UserStore', 'LayoutStore', 'WeekConsumptionStore')
@observer
class StepDayConsumtion extends React.Component<IStepDayConsumptionProps> {
  private stepDayConsumptionEndRef = React.createRef<HTMLDivElement>()

  public constructor(props: IStepDayConsumptionProps) {
    super(props)
    if (this.props.UserStore!.consumptionDays.length === 0) {
      this.props.LayoutStore!.incrementStep()
    }
  }

  public componentDidUpdate() {
    this.scrollToBottom()
  }

  public render() {
    return (
      <>
        {this.props.UserStore!.consumptionDays.map(
          (consumptionDayNumber: number, index: number) => {
            if (index <= this.props.WeekConsumptionStore!.currentDayIndex) {
              return (
                <DayConsumption
                  key={`day-key-${consumptionDayNumber}`}
                  consumptionDayNumber={consumptionDayNumber}
                  stepIndex={index}
                  lengthConsumptionDays={
                    this.props.UserStore!.consumptionDays.length
                  }
                />
              )
            }
          }
        )}
        <div
          style={{ float: 'left', clear: 'both' }}
          ref={this.stepDayConsumptionEndRef}
        />
      </>
    )
  }

  // This scrollToBottom function is the same in Step.tsx, but for this particular component we need to put it here to catch the update
  private scrollToBottom = () => {
    this.stepDayConsumptionEndRef.current.scrollIntoView()
  }
}

export default StepDayConsumtion



// WEBPACK FOOTER //
// ./src/components/StepDayConsumption/StepDayConsumption.tsx